export const userProfile = {
  user_personalInformation: "Mis datos personales",
  user_alias: "Alias",
  user_alias_edit: "Editar alias",
  user_alias_placeholder: "Elige tu alias",
  user_alias_save: "Guardar",
  user_alias_cancel: "Cancelar",
  user_alias_saving: "Guardando...",
  user_alias_success: "Alias actualizado",
  user_alias_error: "No se pudo actualizar el alias",
  user_alias_unavailable: "Este alias ya está en uso",
  user_alias_checking: "Verificando...",
  user_alias_available: "Disponible",
  user_alias_min_length: "Mínimo 3 caracteres",
  user_name: "Nombre",
  user_lastName: "Apellido",
  user_email: "Correo",
  user_phoneNumber: "Teléfono",
  user_birthdate: "Fecha de Nacimiento",
  user_national_id: "Cédula",
  user_state: "Estado",
  user_city: "Ciudad",
  user_support_message:
    "Para realizar cualquier cambio o actualización a su perfil, por favor comuníquese con nuestro departamento de",
  user_support_link: "soporte técnico",

  userProfileImageFormat: "Formato no soportado",
  userProfileImageFormatDesc: "Solo se permiten imágenes JPEG, JPG o PNG.",
  userProfileImageSize: "Imagen demasiado grande",
  userProfileImageSizeDesc: "El tamaño máximo permitido es 3MB.",
  userProfileImageEdit: "Editar",

  profileFollowers: "Seguidores",
  profileFollowing: "Seguidos",
  profileFavoriteGames: "Juegos Favoritos",
  profileRecentGames: "Jugados Recientemente",
  profileFavoriteProviders: "Proveedores Seguidos",
  profileEditProfile: "Editar Perfil",
  profileKeepPlaying: "Seguir Jugando",
  profileFollow: "Seguir",
  profileNoFavorites: "Aún no tienes juegos favoritos",
  profileNoFavoritesDesc: "Los juegos que marques como favoritos aparecerán aquí",
  profileNoRecentGames: "Sin juegos recientes",
  profileNoRecentGamesDesc: "Los juegos que juegues aparecerán aquí",
  profileNoProviders: "Aún no sigues a ningún proveedor",
  profileGamesCount: "{{count}} juegos",

  profileHighlightBigWins: "Big Wins",
  profileHighlightFavorites: "Favoritos",
  profileHighlightRecent: "Recientes",
  profileHighlightLatestWinners: "Últimos Ganadores",
  profileHighlightPopularGames: "Juegos Populares",
  profileHighlightLastPlayed: "Últimos Jugados",
  profileHighlightNoWins: "Aún no hay grandes premios registrados",

  profileFeedTabs: "Pestañas del perfil",
  profileNoBigWins: "Aún no tienes grandes premios",
  profileNoBigWinsDesc: "Tus momentos ganadores aparecerán aquí",

  profileNoFollowers: "Aún no tienes seguidores",
  profileNoFollowing: "Aún no sigues a nadie",
  profileFollowersSoon: "Esta función estará disponible próximamente",

  friendAddFriend: "Seguir",
  friendStatusPending: "Solicitud enviada",
  friendStatusFriends: "Amigos",
  friendRequestSentToast: "Solicitud de amistad enviada",
  friendRequestSentTitle: "Solicitud enviada",
  friendRequestSentBody: "Tu solicitud de amistad ha sido enviada",
  friendRequestReceivedTitle: "Solicitud de amistad",
  friendRequestReceivedBody: "{{alias}} te ha enviado una solicitud de amistad",
  friendUnfriendTitle: "¿Dejar de ser amigos?",
  friendUnfriendDescription: "¿Quieres dejar de ser amigo de @{{alias}}?",
  friendUnfriendConfirm: "Aceptar",
  friendUnfriendCancel: "Cancelar",
  friendUnfriendLoading: "Eliminando...",
};
